export default __webpack_public_path__ + "static/media/img-app.86439ec0.png";